/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { useTokenContext } from '@exo/frontend-common-app-identity-and-access';
import { useSessionContext } from '@exo/frontend-common-session-context';


const TD_AUTH_LOGIN_GQL = gql`
      query Query($code: String!, $redirectParameters: RedirectParameters!) {
        TdUserLoginCode(code: $code, redirectParameters: $redirectParameters) {
          redirectURL
          isExistingUser
          isUserOlder
          isUserEconsentUptoDate
          registeredUserId
          guestUserId
        }
      }
  `;

  export const useTdAuthLogin = ({ tdAuthCode, tdRedirectURL, userLoginFrom,dpmUserId,tokenId}) => {
    
    const session = useSessionContext()
    const tokenContext = useTokenContext()
    console.warn("CONDITIONS FOR CODE CALL:::>",tokenId && dpmUserId !== '')
    const variables = {
      "code": tdAuthCode,
      "redirectParameters": {
        "fromPage":"LoginPage",
        "redirectURL":tdRedirectURL,
        "userLoginFrom":userLoginFrom,
        "guestUserId":dpmUserId
    }
    }

    const [tdCodeCall,{data,loading,error}] = useLazyQuery(TD_AUTH_LOGIN_GQL, {
      variables,
      fetchPolicy:'network-only',
      context: {
        headers: {
          Authorization: 'Bearer ' + tokenId
        },
      },
    });
    return { tdCodeCall,data , loading: loading, error: error};
  };

